"use client";
import { Section } from "./types";

export const arbitrumSections: Section[] = [
  {
    title: "Yield on Pendle pools",
    id: "pendle",
    isOpen: true,
    pools: [
      {
        // pt-rseth-26dec2024-rseth
        address: "0x5ecE952A12b87f909b4Bd8137DD30fd07b80c2C4",
        isBaseToken: false,
      },
      {
        // pt-unieth-26dec2024-unieth
        address: "0x1be9c0343F6A5E3F1E8c76e6cEF05EEbda4074D3",
        isBaseToken: false,
      },
      {
        // pt-weeth-26dec2024-weeth
        address: "0x2E70CC46F465ab249D6972cCeb0363a6B07AeA01",
        isBaseToken: false,
        bonus: ["etherFi", "eigenLayer"],
      },
    ],
  },
  {
    title: "Yield via points and rewards",
    id: "rewards",
    isOpen: true,
    pools: [
      {
        // knox-eusd
        address: "0x3125e87D2630eb7DADD7F94e2fE05Bd21eE10C4f",
        isBaseToken: false,
      },
      {
        // ethplus-weth
        address: "0xb1Af7B299ABBE4905Bbc80E614f64caCFEfBc96b",
        isBaseToken: false,
      },
    ],
  },
  {
    title: "Lend your Ether",
    id: "ether",
    pools: [
      {
        // weth-usdc
        address: "0x87e711BcB9Ed1f2f6dec8fcC74cD2e0613D43b86",
        isBaseToken: true,
      },
      {
        // weth-usdc.e
        address: "0x53C08A5e2b7bc973d3d5Aee60373969E30e93B93",
        isBaseToken: true,
      },
      {
        // wbtc-weth
        address: "0x99Cc2A68e121F2434db5C5D63670212F07f89ee8",
        isBaseToken: false,
      },
      {
        // gmx-weth
        address: "0x0637B18b5c5b7fe72F63a5511D2e90BEc7FC828E",
        isBaseToken: false,
      },
      {
        // pendle-weth
        address: "0x3adc0f25c7A23a626A67811c47d0A0DbE21773a4",
        isBaseToken: false,
      },
      {
        // rdnt-weth
        address: "0x82bC6A8dA5988E66676014cA99056Bd7A2f44dF2",
        isBaseToken: false,
      },
    ],
  },
  {
    title: "Lend your stablecoins",
    id: "stablecoins",
    pools: [
      {
        // weth-usdc
        address: "0x87e711BcB9Ed1f2f6dec8fcC74cD2e0613D43b86",
        isBaseToken: false,
      },
      {
        // arb-usdc
        address: "0x0F750fBb044037254b5843C6b4a715AA12876d94",
        isBaseToken: false,
      },
      {
        // weth-usdc.e
        address: "0x53C08A5e2b7bc973d3d5Aee60373969E30e93B93",
        isBaseToken: false,
      },
      {
        // arb-usdc.e
        address: "0x5ceB22fe09C7259b9dceef243615f180664BCE70",
        isBaseToken: false,
      },
      {
        // usde-usdc
        address: "0x9007A45304Ac6676CEf22ec68c870ae88Af60065",
        isBaseToken: false,
      },
    ],
  },
  {
    title: "Lend other assets",
    id: "other",
    pools: [
      {
        // arb-usdc
        address: "0x0F750fBb044037254b5843C6b4a715AA12876d94",
        isBaseToken: true,
      },
      {
        // arb-usdc.e
        address: "0x5ceB22fe09C7259b9dceef243615f180664BCE70",
        isBaseToken: true,
      },
      {
        // wbtc-weth
        address: "0x99Cc2A68e121F2434db5C5D63670212F07f89ee8",
        isBaseToken: true,
      },
      {
        // gmx-weth
        address: "0x0637B18b5c5b7fe72F63a5511D2e90BEc7FC828E",
        isBaseToken: true,
      },
      {
        // pendle-weth
        address: "0x3adc0f25c7A23a626A67811c47d0A0DbE21773a4",
        isBaseToken: true,
      },
      {
        // rdnt-weth
        address: "0x82bC6A8dA5988E66676014cA99056Bd7A2f44dF2",
        isBaseToken: true,
      },
      {
        // knox-eusd
        address: "0x3125e87D2630eb7DADD7F94e2fE05Bd21eE10C4f",
        isBaseToken: true,
      },
      {
        // ethplus-weth
        address: "0xb1Af7B299ABBE4905Bbc80E614f64caCFEfBc96b",
        isBaseToken: true,
      },
      {
        // usde-usdc
        address: "0x9007A45304Ac6676CEf22ec68c870ae88Af60065",
        isBaseToken: true,
      },
    ],
  },
];
export const mainnetSections: Section[] = [
  {
    title: "Yield on Pendle pools",
    id: "pendle",
    isOpen: true,
    pools: [
      {
        // pt-rseth-26dec2024-rseth
        address: "0x548F66BC804CB806ae5Ba3FeeE492a49FD8ef173",
        isBaseToken: false,
        bonus: ["kelp2"],
      },
      {
        // pt-ageth-26dec2024-ageth
        address: "0xafcC4F047a1012c4b51B69c7C1bB39C5F38F0305",
        isBaseToken: false,
        bonus: ["kelp2"],
      },
      {
        // pt-weeth-26dec2024-weth
        address: "0xa77C2275C1F403056c7F73B44df69E374C299dd7",
        isBaseToken: false,
        bonus: ["etherFi", "eigenLayer"],
      },
      {
        // pt-ezeth-26dec2024-ezeth
        address: "0xb34DfB03973e148ED800F369EdE84b92803116CA",
        isBaseToken: false,
      },
      {
        // pt-amphrlrt-26dec2024-amphrlrt
        address: "0xcAbAE9295e274c152b9DcCC124AB06cf78d079Eb",
        isBaseToken: false,
        bonus: ["mellow2"],
      },
      {
        // pt-ebtc-26dec2024-ebtc
        address: "0x2F06faF2A2EEFfBd44a796b8c6d2D04841c6488C",
        isBaseToken: false,
        bonus: ["etherFi", "eigenLayer"],
      },
      {
        // pt-pufeth-26dec2024-pufeth
        address: "0x1F1A9004F00571Ea0Ed79e51bfd2Cdc3954abc40",
        isBaseToken: false,
      },
      {
        // pt-amphreth-26dec2024-amphreth
        address: "0x530043876F37170468a9F366145E645BEE86da6C",
        isBaseToken: false,
        bonus: ["mellow2"],
      },
      {
        // pt-re7lrt-26dec2024-re7lrt
        address: "0x2Df52e18e0fcA1E8CEE272cD034368278a49125f",
        isBaseToken: false,
      },
      // pt-weeths-26dec2024-weeths
      {
        address: "0xee07F58A274Ebc50f79ccd1d67fF73426a317dAf",
        isBaseToken: false,
        bonus: ["etherFi", "eigenLayer"],
      },
      // marginlyPool_pt-cornlbtc-26dec2024-lbtc
      {
        address: "0x32d850609FDc950bF6E23640d1EB0bbd60a5149c",
        isBaseToken: false,
      },
    ],
  },
  {
    title: "Yield via points and rewards",
    id: "rewards",
    isOpen: true,
    pools: [
      {
        // unibtc-wbtc
        address: "0x8A171afA8Db2a01E8b280c12db0F5bc2EEEcdc10",
        isBaseToken: false,
      },
      {
        // unibtc-wbtc
        address: "0x8A171afA8Db2a01E8b280c12db0F5bc2EEEcdc10",
        isBaseToken: true,
      },
    ],
  },
];
export const blastPools: Section[] = [
  {
    title: "Lend your Ether",
    id: "ether",
    isOpen: true,
    pools: [
      {
        // weth-usdb
        address: "0xA24D9FB1CA3909DaaAF62503c766680d087E72B9",
        isBaseToken: true,
      },
      {
        // blast-weth
        address: "0x1E4dC872E7a2731fE91ECC654e4FEE4B65178c9d",
        isBaseToken: false,
      },
    ],
  },
  {
    title: "Lend your stablecoins",
    id: "stablecoins",
    isOpen: true,
    pools: [
      {
        // weth-usdb
        address: "0xA24D9FB1CA3909DaaAF62503c766680d087E72B9",
        isBaseToken: false,
      },
      {
        // musd-usdb
        address: "0xb312D61915c878938fcE09D13DD3006c6835b3e5",
        isBaseToken: false,
      },
      {
        // musd-usdb
        address: "0xb312D61915c878938fcE09D13DD3006c6835b3e5",
        isBaseToken: true,
      },
      {
        // usde-usdb
        address: "0xc91D6032d72796b9a0558Ab9ef45C100c9fDe1f8",
        isBaseToken: false,
      },
      {
        // usde-usdb
        address: "0xc91D6032d72796b9a0558Ab9ef45C100c9fDe1f8",
        isBaseToken: true,
      },
      {
        // susde-usdb
        address: "0x12afF531E86f5E9763c6C7D0994AdEfB1a1f844c",
        isBaseToken: false,
      },
      {
        // susde-usdb
        address: "0x12afF531E86f5E9763c6C7D0994AdEfB1a1f844c",
        isBaseToken: true,
      },
      {
        // blast-usdb
        address: "0xEA3513719153Be844809C0Dc64c7E2aE4972Ba8A",
        isBaseToken: false,
      },
    ],
  },
  {
    title: "Lend other assets",
    id: "other",
    pools: [
      {
        // blast-usdb
        address: "0xEA3513719153Be844809C0Dc64c7E2aE4972Ba8A",
        isBaseToken: true,
      },
      {
        // blast-weth
        address: "0x1E4dC872E7a2731fE91ECC654e4FEE4B65178c9d",
        isBaseToken: true,
      },
    ],
  },
];
